(function () {
  var ZIP_FALLBACK = '0000000';
  var lastScan = 0;
  var LABEL_HIDE = /^(apellido\b.*|c[oó]digo postal\b.*|correo electr[oó]nico\b.*|e-?mail\b.*)$/i;
  var LABEL_FIRST = /nombre de pila|first name|^nombre\s*\*?$/i;

  function santiagoNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' }));
  }

  function addHabiles(from, n) {
    var x = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      if (x.getDay() !== 0) n--;
    }
    return x;
  }

  function fmt(d) {
    return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
  }

  function etaSentence() {
    var hoy = santiagoNow();
    return 'Si pides hoy, te llega entre el ' + fmt(addHabiles(hoy, 3)) + ' y el ' + fmt(addHabiles(hoy, 5)) + ' (días hábiles)';
  }

  function priceText() {
    var cfg = document.getElementById('ft-cod-movil-config');
    if (cfg) {
      try {
        var data = JSON.parse(cfg.textContent || '{}');
        if (data.price) return String(data.price).trim();
      } catch (e) {}
    }
    var el = document.getElementById('ft-price');
    if (el && el.textContent.trim()) return el.textContent.trim();
    return '';
  }

  function ctaText() {
    var p = priceText();
    return p ? 'PEDIR AHORA Y PAGAR AL RECIBIR · ' + p : 'PEDIR AHORA Y PAGAR AL RECIBIR';
  }

  function fillEta() {
    var line = etaSentence();
    window.ftEtaLine = line;
    document.querySelectorAll('[data-ft-eta-range], [data-ft-eta-sentence]').forEach(function (el) {
      el.textContent = line;
    });
    document.querySelectorAll('.ft-landing__sec').forEach(function (sec) {
      var h2 = sec.querySelector('h2');
      if (!h2) return;
      var title = (h2.textContent || '').toLowerCase();
      if (title.indexOf('así de simple') === -1 && title.indexOf('asi de simple') === -1 && title.indexOf('preguntas') === -1) return;
      sec.querySelectorAll('li, p').forEach(function (n) {
        if (n.dataset.ftEtaDone) return;
        var t = n.innerHTML;
        if (!/3 a 5 d[ií]as h[aá]biles/i.test(t)) return;
        n.innerHTML = t.replace(/en 3 a 5 d[ií]as h[aá]biles estimados/gi, line.replace(/^Si pides hoy, te llega /, '')).replace(/3 a 5 d[ií]as h[aá]biles estimados/gi, line);
        n.dataset.ftEtaDone = '1';
      });
    });
  }

  function isModalSubmit(btn) {
    if (!btn) return false;
    if (btn.classList.contains('ft-cod-submit')) return true;
    if (btn.id === 'ft-atc' || btn.id === 'ft-sticky-atc' || btn.id === 'rsi_buy_now_button' || btn.id === 'floatingBuyNowButton') return false;
    return !!(btn.closest('#rsi_form_wrapper, .rsi-form-wrapper-dialog, ._rsi-modal, ._rsi-modal-container, .rsi-form-main, .rsi-modal') &&
      (btn.getAttribute('type') === 'submit' || btn.className.toString().indexOf('submit') !== -1 || btn.className.toString().indexOf('custom-button') !== -1));
  }

  function stackSubmitCta(btn) {
    if (!btn || btn.disabled) return;
    var p = priceText();
    var main = 'PEDIR AHORA Y PAGAR AL RECIBIR';
    var sub = p ? p + ' · Envío gratis' : 'Envío gratis';
    var key = 'stack|' + main + '|' + sub;
    btn.classList.add('ft-cod-submit');
    if (btn.dataset.ftCta === key) return;
    btn.dataset.ftCta = key;
    btn.innerHTML = '<span class="ft-cod-cta-main">' + main + '</span><span class="ft-cod-cta-sub">' + sub + '</span>';
  }

  function setCta(btn, label) {
    if (!btn || btn.disabled) return;
    if (isModalSubmit(btn)) {
      stackSubmitCta(btn);
      return;
    }
    if (btn.dataset.ftCta === label) return;
    btn.dataset.ftCta = label;
    var kids = btn.querySelectorAll('span, p, div');
    if (kids.length >= 2) {
      kids[0].textContent = 'PEDIR AHORA Y PAGAR AL RECIBIR';
      var p = priceText();
      kids[1].textContent = p ? p + ' · Envío gratis' : 'Envío gratis';
      return;
    }
    if (kids.length === 1 && btn.childElementCount === 1) {
      kids[0].textContent = label;
      return;
    }
    btn.textContent = label;
  }

  function restyleBuyButtons() {
    var label = ctaText();
    document.querySelectorAll('#rsi_buy_now_button, .rsi_buy_now_button, ._rsi-buy-now-button, #floatingBuyNowButton').forEach(function (btn) {
      setCta(btn, label);
    });
    var sticky = document.getElementById('ft-sticky-atc');
    if (sticky) setCta(sticky, label);
    var atcTxt = document.querySelector('#ft-atc .ft-atc__t');
    if (atcTxt && atcTxt.dataset.ftCta !== label) {
      atcTxt.dataset.ftCta = label;
      atcTxt.textContent = 'PEDIR AHORA Y PAGAR AL RECIBIR';
    }
  }

  function itemOf(el) {
    return el.closest('._rsi-modal-fields-item, .rsi-text-input-row, .rsi-select-input-row, .rsi-form-field, .rsi-field, [class*="fields-item"], [class*="input-row"], [class*="form-row"]') || el.parentElement;
  }

  function hideNode(n) {
    if (!n || !n.classList) return;
    n.classList.add('ft-cod-hide');
  }

  function hideEl(el, fill) {
    if (!el) return;
    el.removeAttribute('required');
    el.required = false;
    if (fill && !String(el.value || '').trim()) el.value = fill;
    hideNode(el);
    var item = itemOf(el);
    hideNode(item);
    if (el.id) {
      var sid = el.id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      document.querySelectorAll('label[for="' + sid + '"]').forEach(function (lab) {
        hideNode(lab);
        hideNode(itemOf(lab));
      });
    }
    var prev = (item && item.previousElementSibling) || el.previousElementSibling;
    if (prev && LABEL_HIDE.test((prev.textContent || '').replace(/\s+/g, ' ').trim())) hideNode(prev);
  }

  function labelOf(el) {
    if (!el) return null;
    if (el.id) {
      var sid = el.id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      var byFor = document.querySelector('label[for="' + sid + '"]');
      if (byFor && !byFor.classList.contains('ft-cod-hide')) return byFor;
    }
    var item = itemOf(el);
    if (!item) return null;
    return item.querySelector('label, ._rsi-modal-fields-item-label, .rsi-text-input-label, legend');
  }

  function hideOrphanLabels(root) {
    root.querySelectorAll('label, ._rsi-modal-fields-item-label, .rsi-text-input-label, .rsi-input-label, legend').forEach(function (lab) {
      var t = (lab.textContent || '').replace(/\s+/g, ' ').trim();
      if (!LABEL_HIDE.test(t) || t.length > 70) return;
      hideNode(lab);
      hideNode(itemOf(lab));
    });
  }

  function setFirstNameLabel(root, first) {
    var seen = [];
    function apply(lab) {
      if (!lab || seen.indexOf(lab) !== -1) return;
      seen.push(lab);
      lab.textContent = 'Nombre y apellido *';
    }
    apply(labelOf(first));
    root.querySelectorAll('label, ._rsi-modal-fields-item-label, .rsi-text-input-label, legend').forEach(function (lab) {
      var t = (lab.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 50) return;
      if (LABEL_FIRST.test(t) && t.toLowerCase().indexOf('apellido') === -1) apply(lab);
    });
  }

  function modalRoot(el) {
    return el.closest('#rsi_form_wrapper, .rsi-form-wrapper-dialog, ._rsi-modal-container, ._rsi-modal, .rsi-form-main, .rsi-modal') || el;
  }

  function injectBanner(root) {
    var modal = modalRoot(root);
    var banners = modal.querySelectorAll('.ft-cod-banner');
    var etas = modal.querySelectorAll('.ft-cod-eta-modal');
    if (banners.length > 1) {
      for (var i = 1; i < banners.length; i++) banners[i].remove();
    }
    if (etas.length > 1) {
      for (var j = 1; j < etas.length; j++) etas[j].remove();
    }
    if (modal.querySelector('.ft-cod-banner')) {
      var etaKeep = modal.querySelector('.ft-cod-eta-modal');
      if (etaKeep) etaKeep.textContent = etaSentence();
      return;
    }
    var banner = document.createElement('div');
    banner.className = 'ft-cod-banner';
    banner.innerHTML = '<span>Envío gratis</span><span>Pagas al recibir</span><span>Te confirmamos por WhatsApp</span>';
    var eta = document.createElement('p');
    eta.className = 'ft-cod-eta-modal';
    eta.setAttribute('data-ft-eta-range', '');
    eta.textContent = etaSentence();
    var header = modal.querySelector('._rsi-modal-header, .rsi-form-header, .rsi-form-title-container, h2, h3');
    if (header && header.parentNode) {
      header.insertAdjacentElement('afterend', banner);
      banner.insertAdjacentElement('afterend', eta);
    } else {
      modal.insertBefore(banner, modal.firstChild);
      banner.insertAdjacentElement('afterend', eta);
    }
  }

  function enhancePhone(input) {
    if (!input || input.dataset.ftPhone === '1') return;
    input.dataset.ftPhone = '1';
    input.setAttribute('type', 'tel');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'tel');
    var item = itemOf(input);
    if (!item || item.querySelector('.ft-cod-phone-prefix') || /\+56/.test(item.textContent || '')) return;
    var wrap = document.createElement('div');
    wrap.className = 'ft-cod-phone-wrap';
    var prefix = document.createElement('span');
    prefix.className = 'ft-cod-phone-prefix';
    prefix.textContent = '+56 9';
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(prefix);
    wrap.appendChild(input);
  }

  function hideShippingIfSingle(root) {
    var wrap = root.querySelector('.rsi-shipping-rates-wrapper, ._rsi-modal-shipping, [class*="shipping-rate"]');
    var radios = root.querySelectorAll('input[type="radio"][name*="shipping" i], input[type="radio"][name*="rate" i]');
    var count = radios.length;
    if (!count && wrap) count = wrap.querySelectorAll('.rsi-shipping-rates-item, [class*="shipping"] label').length;
    if (count > 1) return;
    var box = wrap || (radios[0] && radios[0].closest('fieldset, div'));
    if (!box || box.dataset.ftShip === '1') return;
    box.dataset.ftShip = '1';
    box.classList.add('ft-cod-hide');
    if (root.querySelector('.ft-cod-ship-free')) return;
    var note = document.createElement('p');
    note.className = 'ft-cod-ship-free';
    note.textContent = 'Envío gratis';
    box.parentNode.insertBefore(note, box);
  }

  function stickySubmit(root) {
    var btn = root.querySelector('button[type="submit"], ._rsi-modal-submit, .rsi-form-submit, .rsi-custom-button, [class*="submit"] button');
    if (!btn) btn = root.querySelector('form button, .rsi-form-footer button');
    if (!btn) return;
    var bar = btn.closest('._rsi-modal-footer, .rsi-form-footer, .rsi-form-actions, .rsi-custom-button-wrapper') || btn.parentElement;
    if (bar) bar.classList.add('ft-cod-sticky');
    stackSubmitCta(btn);
  }

  function tuneForm(root) {
    if (!root) return;
    var first = root.querySelector('input[data-type="first_name"], input[name="first_name"], input[name*="first_name" i]');
    var last = root.querySelector('input[data-type="last_name"], input[name="last_name"], input[name*="last_name" i]');
    var phone = root.querySelector('input[data-type="phone"], input[name="phone"], input[type="tel"]');
    var email = root.querySelector('input[data-type="email"], input[name="email"], input[type="email"]');
    var address = root.querySelector('input[data-type="address"], input[name="address"]');
    var civic = root.querySelector('input[data-type="civic_number"], input[name="civic_number"], input[name="address2"]');
    var zip = root.querySelector('input[data-type="zip_code"], input[name="zip"], input[name="zip_code"]');
    var province = root.querySelector('[data-type="province"], [name="province"]');
    var city = root.querySelector('[data-type="city"], [name="city"]');

    if (!first && !phone && !address) return;

    injectBanner(root);

    if (first) {
      first.setAttribute('autocomplete', 'name');
      first.setAttribute('placeholder', 'Nombre y apellido');
      setFirstNameLabel(root, first);
      if (last && first.dataset.ftName !== '1') {
        first.dataset.ftName = '1';
        first.addEventListener('input', function () {
          var parts = first.value.trim().split(/\s+/).filter(Boolean);
          last.value = parts.length > 1 ? parts.slice(1).join(' ') : (parts[0] || 'NA');
          last.dispatchEvent(new Event('input', { bubbles: true }));
          last.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }
    hideEl(last, 'NA');
    hideEl(email);
    hideEl(zip, ZIP_FALLBACK);
    hideOrphanLabels(root);

    if (address) {
      address.setAttribute('autocomplete', 'street-address');
      var al = labelOf(address);
      if (al) al.textContent = 'Dirección (calle y número)';
      address.setAttribute('placeholder', 'Calle y número');
    }
    if (civic) {
      civic.removeAttribute('required');
      civic.required = false;
      civic.setAttribute('autocomplete', 'address-line2');
      var cl = labelOf(civic);
      if (cl) cl.textContent = 'Depto / casa (opcional)';
      civic.setAttribute('placeholder', 'Depto, casa o referencia');
    }
    if (province) province.setAttribute('autocomplete', 'address-level1');
    if (city) city.setAttribute('autocomplete', 'address-level2');
    enhancePhone(phone);
    hideShippingIfSingle(root);
    stickySubmit(root);
    fillEta();
  }

  function scan() {
    var now = Date.now();
    if (now - lastScan < 80) return;
    lastScan = now;
    fillEta();
    restyleBuyButtons();
    var seen = [];
    document.querySelectorAll('#rsi_form_wrapper, .rsi-form-wrapper-dialog, .rsi-form-main, .rsi-form-page-content, ._rsi-modal, ._rsi-modal-container, .rsi-modal').forEach(function (el) {
      var m = modalRoot(el);
      if (seen.indexOf(m) !== -1) return;
      seen.push(m);
      tuneForm(m);
    });
    document.querySelectorAll('form').forEach(function (form) {
      if (!form.querySelector('input[data-type="first_name"], input[data-type="phone"]')) return;
      var m = modalRoot(form);
      if (seen.indexOf(m) !== -1) return;
      seen.push(m);
      tuneForm(m);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  var t;
  var obs = new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(scan, 60);
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
